import React, { useEffect, useState } from "react";
import LoaderSpinner from "../common/Loader";
import Table from "react-bootstrap/Table";
import ActionItems from "../common/showActions";
import { getConsignmentOutboundListing, updateOutboundStatus, updateOutboundStatusTransit } from "../../store/actions/inventory.action";
import { useDispatch, useSelector } from "react-redux";
import { dateFilters, featureSubmodulePermission, inventoryManagement, numOfPage, permissionMarkedPickedOutbound, permssionCreate, permssionEdit, permssionView, SUBF_INBOUND, SUBF_OUTBOUND } from "../../constant";
import BatchPagination from "../batch/BatchPagination";
import FilterOutbound from "./filterOutbound";
import ViewImage from "../common/ViewImage";
import _ from "lodash";
import { getSellersforMultipleCompany } from "../../store/actions";
import SearchProduct from "../Inventory/Product/searchProduct";
import { checkPermission, getStatusClass, renderTableRow } from "../../config/utils";
import { useNavigate } from "react-router";
import { outboundBackDetails } from "../../store/actions/employee";
import AlertDialogModal from "../common/AlertDialog";
import { toast } from "react-toastify";
import BulkUpload from "../Uploads/UploadDialog";
import moment from 'moment';
import OutboundItemList from "./OutboundItemList";
import Dropdown from 'react-bootstrap/Dropdown';
import { getMergedPdf } from "../../store/actions/batch.action";
import PropTypes from "prop-types";

const OutboundComponent = (props) => {
  const [outBoundlist, setOutBoundlist] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [checkAll, setCheckAll] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState({
    show: false,
    type: 0,
  });
  const { consignmentOutboundData, consignmentOutboundStatus } = useSelector(
    (state) => state.InventoryOutboundManagement
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [showHideImageModal, setShowHideImageModal] = useState(false);
  const [allSellers, setAllSellers] = useState([]);
  const getMultipleSellers = useSelector(
    (state) => state?.company?.getMultipleCompanySellers
  );
  const [sellerList, setSellerList] = useState([]);
  const [csvModalShow, setCsvModalShow] = useState(false);
  const userDetails = useSelector((state) => state.auth.user);
  const { prevState } = useSelector((state) => state.employee);

  let dataLoad = {
    searchKeyword: '',
    pageIndex: 1,
    pageSize: 30,
    sortColumn: '',
    sortOrder: 'DESCENDING',
    carrierIdList: [],
    consignmentStatusIdList: [],
    consignmentTypeIdList: [],
    outboundStatusIdList: [],
    trackingNumber: "",
    productSku: "",
    totalPages: 1,
    totalRecords: 0,
    numberOfPage: 30,
    showSearch: true,
    searchTxt: '',
    showFilter: false,
    sortingColumn: '',
    outboundNumber: '',
    name: "",
    consignmentCompanyIdList: [],
    consignmentSellerIdList: [],
  };
  const [filterValue, setFilterValue] = useState({});

  const handleFilterToggle = (key, value) => {
    setFilterValue({ ...filterValue, [key]: value });
  }

  const setCurrentPagePagination = (value) => {
    setFilterValue({ ...filterValue, pageIndex: value });
  }
  const setTotalNumberOfPage = (value) => {
    setFilterValue({ ...filterValue, numberOfPage: value, pageIndex: 1 });
  }

  useEffect(() => {
    if (consignmentOutboundData?.TotalRecords) {
      setFilterValue({ ...filterValue, totalRecords: consignmentOutboundData?.TotalRecords, totalPages: Math.ceil(consignmentOutboundData?.TotalRecords / filterValue.numberOfPage) });
    }
    if (consignmentOutboundData?.OutboundList) {
      setOutBoundlist(consignmentOutboundData?.OutboundList);
    }
  }, [consignmentOutboundData]);

  useEffect(() => {
    if (!_.isEmpty(prevState)) {
      setFilterValue({ ...filterValue, ...prevState });
    } else {
      setFilterValue({
        searchKeyword: '',
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        carrierIdList: [],
        consignmentStatusIdList: [],
        consignmentTypeIdList: [],
        outboundStatusIdList: [],
        trackingNumber: "",
        productSku: "",
        totalPages: 1,
        totalRecords: 0,
        numberOfPage: 30,
        showSearch: true,
        searchTxt: '',
        showFilter: false,
        sortingColumn: '',
        outboundNumber: '',
        name: "",
        consignmentCompanyIdList: [],
        consignmentSellerIdList: [],
        OutBoundCreationFrom: moment(new Date()).utc(true).format(),
        OutBoundCreationTo: null,
      });
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(filterValue)) {
      fetchConsignmentOutboundLisiting();
    }
    setCheckAll(false);
  }, [filterValue.numberOfPage, filterValue.pageIndex, filterValue.sortColumn, filterValue.sortOrder]);

  useEffect(() => {
    if (consignmentOutboundStatus === "pending") {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [consignmentOutboundStatus]);

  const handleSortingClass = (columnName, isArrow = false) => {
    if (isArrow) {
      return filterValue.sortColumn === columnName && filterValue.sortOrder === "ASCENDING"
        ? "fa fa-arrow-up"
        : "fa fa-arrow-down";
    }
    return filterValue.sortColumn === columnName ? "active sortBtn" : "sortColumn sortBtn";
  };

  const handleSortingColumn = (event, sortColumn) => {
    event.preventDefault();
    let newSortOrder = filterValue.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    setFilterValue({
      ...filterValue,
      sortColumn: sortColumn,
      sortOrder: newSortOrder,
      searchKeyword: filterValue.searchTxt,
    });
  };

  const handleSearchText = (value) => {
    setFilterValue({
      ...filterValue,
      searchTxt: value
    })
  }

  useEffect(() => {
    if (filterValue?.consignmentCompanyIdList?.length === 0) {
      setSellerList(allSellers);
      return;
    }
    if (
      getMultipleSellers?.Entity?.listSellerMasterOrdersEntity &&
      getMultipleSellers?.Entity?.listSellerMasterOrdersEntity.length > 0
    ) {
      let data = getMultipleSellers?.Entity?.listSellerMasterOrdersEntity.map(
        (item, index) => {
          return {
            ...item,
            label: item.sellerAndCompany,
            value: index + 1,
          };
        }
      );
      setSellerList([...data]);
    }
  }, [getMultipleSellers]);

  const fetchConsignmentOutboundLisiting = () => {
    let data = {
      ...filterValue,
      pageSize: filterValue.numberOfPage,
      sortColumn: filterValue.sortColumn,
      sortOrder: filterValue.sortOrder,
      searchKeyword: filterValue.searchTxt,
      consignmentTypeIdList: _.map(filterValue.consignmentTypeIdList, "id"),
      carrierIdList: _.map(filterValue.carrierIdList, "carrierCompanyId"),
      outboundStatusIdList: _.map(filterValue.consignmentStatusIdList, "id"),
      trackingNumber: filterValue.trackingNumber,
      consignmentNumber: filterValue.consignmentNumber,
      sellerIdList: _.map(filterValue.consignmentSellerIdList, "id"),
      companyIdList: _.map(filterValue.consignmentCompanyIdList, "Id"),
      marketPlaceIdList: _.map(filterValue.marketPlaceIdList, "id"),
      productSku: filterValue.productSku,
      name: filterValue.name,
      outboundNumber: filterValue.outboundNumber,
    };
    dispatch(getConsignmentOutboundListing(data));
  };

  const handleSearchFilter = (e, type) => {
    if (type === "clear") {
      let data = JSON.parse(JSON.stringify(dataLoad));
      data.showFilter = false;
      data.numberOfPage = filterValue.numberOfPage;
      setFilterValue(data);
      dispatch(getConsignmentOutboundListing(data));
      setSellerList(allSellers)
      return;
    } else if (type === "search") {
      let data = JSON.parse(JSON.stringify(dataLoad));
      data.showSearch = true;
      data.searchTxt = '';
      setFilterValue(data);
    }
    setCheckAll(false);
    fetchConsignmentOutboundLisiting();
  };

  const handleMultiSelect = (value, name) => {
    setFilterValue({ ...filterValue, [name]: value });
    if (name === "consignmentCompanyIdList") {
      let companyData = _.map(value, "Id");
      dispatch(getSellersforMultipleCompany(companyData));
      if (filterValue?.consignmentSellerIdList?.length) {
        const filteredSellers = filterValue.consignmentSellerIdList.filter(seller =>
          companyData.includes(parseInt(seller.companyIds))
        );
        setFilterValue({ ...filterValue, consignmentSellerIdList: filteredSellers, consignmentCompanyIdList: value })

      }
    }
  };

  const handleFilter = () => {
    let dataFilters = {
      ...filterValue,
      sortingColumn: '',
      sortOrder: 'DESCENDING',
      pageIndex: 1
    }
    fetchConsignmentOutboundLisiting();
    setFilterValue(dataFilters);
  };

  const handleNavigateToOutbound = (item, type = "") => {
    dispatch(outboundBackDetails(filterValue));
    if (type) {
      navigate(`/outbound/${item.id}`, {
        state: {
          data: item,
          userActionEdit: type === "edit",
          isEdit: item.outboundStatusId === 1 && type === "edit",
        },
      });
      return;
    }
    navigate(`/outbound/${item}`, {
      state: {
        data: item,
        isEdit: true,
        userActionEdit: '',
      },
    });
  };

  const handleHistoryPage = (item) => {
    dispatch(outboundBackDetails(filterValue));
    navigate(`/outbound/history-${item.id}`, {
      state: {
        data: item,
        editable: false,
        type: "outbound",
      },
    });
  }

  const handleCheckAll = (e) => {
    let { checked } = e.target;
    let outBoundlistClone = _.cloneDeep(outBoundlist);
    outBoundlistClone.forEach((item) => {
      item.isChecked = (item.consignmentOrder === 2 || item.consignmentOrder === 3) && checked;
    });
    setOutBoundlist(outBoundlistClone);
    setCheckAll(checked);
  }

  const handleCheckItem = (e, index) => {
    let { name, checked } = e.target;
    let outBoundlistClone = _.cloneDeep(outBoundlist);
    outBoundlistClone[index][name] = checked;
    setOutBoundlist(outBoundlistClone);
  }

  const handleChangeStatus = async (e) => {
    let findChecked = outBoundlist.filter(item => item.isChecked);
    let ids = _.map(findChecked, "id");
    setLoader(true);
    let statusRes;
    if (showAlert.type === 5) {
      statusRes = await Promise.resolve(dispatch(updateOutboundStatus(ids)));
    } else if (showAlert.type === 6) {
      statusRes = await Promise.resolve(dispatch(updateOutboundStatusTransit(ids)));
    }
    if (statusRes && statusRes.data.Status === 200) {
      setShowAlert({
        show: false,
        type: 0,
      });
      setLoader(false);
      handleSearchFilter(e, '');
      toast.success('Status updated successfully');
    } else {
      setLoader(false);
      setShowAlert({
        show: false,
        type: 0,
      });
      toast.error('Something went wrong');
    }
  }

  const handleUploadDialog = () => {
    setFilterValue(dataLoad)
    setCsvModalShow(!csvModalShow);
    setLoader(false);
  };

  const handleStatusChange = (status, actionType) => {
    setShowAlert({ show: true, type: status, actionType: actionType });
  };

  const handleDownloadLabel = async () => {
    setLoader(true);
    let checkedData = outBoundlist.filter((item) => {
      if (item?.isChecked) {
        return item;
      }
    });
    let checkedDataLength = outBoundlist.filter(item => item.isChecked).length;
    if (checkedData.length) {
      let data = _.map(checkedData, "outboundNumber");
      let mergedRes = await getMergedPdf(data);
      if (mergedRes?.data?.Status === 200) {
        if (checkedDataLength !== checkedData.length) {
          toast.info('Some of the orders may have already delivered');
        } else {
          toast.success('Reprint label generated successfully');
        }
        let updateIsChecked = outBoundlist.map((record) => {
          return {
            ...record,
            isChecked: false,
          };
        });
        setOutBoundlist(updateIsChecked);
        window.open(mergedRes.data.Entity);
      }
    } else {
      toast.error('Can not reprint selected order(s) label');
    }
    setLoader(false);
  };

  const handleQuickDateFilter = (e) => {
    const { value } = e.target;
    const data = JSON.parse(JSON.stringify(filterValue));
    const days = Number(value);
    if (days === 0) {
      data.OutBoundCreationFrom = moment().utc(true).startOf('day').toISOString();
      data.OutBoundCreationTo = null;
    } else if (days === 1) {
      data.OutBoundCreationFrom = moment().subtract(1, 'days').utc(true).startOf('day').toISOString();
      data.OutBoundCreationTo = moment().subtract(1, 'days').utc(true).endOf('day').toISOString();
    } else {
      data.OutBoundCreationFrom = moment().subtract(days, 'days').utc(true).startOf('day').toISOString();
      data.OutBoundCreationTo = moment().utc(true).endOf('day').toISOString();
    }
    data.pageIndex = 1;
    data.quickFilter = value;
    setFilterValue(data);
    dispatch(getConsignmentOutboundListing(data));
  };

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          <span>Outbound</span>
          <div className="top_right_button_container historyButton">
            <span className="shippingHistoryPeriod item">
              <div className="title mr-2">Period</div>
              <select
                className="form-control carrierSelect quickFilter"
                onChange={(e) => handleQuickDateFilter(e)}
                value={filterValue.quickFilter}
                disabled={loader}
              >
                {dateFilters.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </span>
            <button
              className="btn cus-seconday-bg-btn top-btn blkUploadBtn"
              onClick={() => setCsvModalShow(true)}
            >
              Bulk Upload
            </button>
            <button
              className="btn cus-seconday-bg-btn top-btn"
              disabled={!outBoundlist?.filter((item) => item.isChecked).length || loader}
              onClick={handleDownloadLabel}
            >
              Reprint Selected
            </button>

            {checkPermission(inventoryManagement, SUBF_OUTBOUND, permssionCreate, featureSubmodulePermission, props.employeePermissions) && (
              <button
                className="btn cus-seconday-bg-btn top-btn"
                onClick={() => handleNavigateToOutbound(0)}
              >
                Add New
              </button>
            )}

            <button
              className="btn cus-seconday-bg-btn top-btn addNewProduct"
              onClick={() => handleFilterToggle('showFilter', !filterValue.showFilter)}
            >
              Filter
            </button>

            {userDetails?.Value?.isSuperAdmin && (
              <Dropdown className="dropBtnInline" drop="down">
                <Dropdown.Toggle
                  className="btn cus-seconday-bg-btn top-btn"
                  id="dropdown-basic"
                  disabled={!outBoundlist.filter(item => item.isChecked).length}
                >
                  Update
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item className="picked" onClick={(e) => handleStatusChange(5, 'Picked')}>Mark - Picked</Dropdown.Item>
                  <Dropdown.Item className="Intransit" onClick={(e) => handleStatusChange(6, 'In-Transit')}>Mark - Intransit</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>
        </div>
        <div className="">
          <SearchProduct
            showSearch={filterValue.showSearch}
            searchTxt={filterValue.searchTxt}
            setSearchTxt={handleSearchText}
            handleReset={handleSearchFilter}
            handleSearchFilter={handleSearchFilter}
            placeHolderText="Search by SKU, Outbound Id, Name, Consignment Type, Carrier, Tracking Number or Status"
          />
        </div>

        {filterValue.showFilter && (
          <FilterOutbound
            showFilter={filterValue.showFilter}
            dispatch={dispatch}
            useSelector={useSelector}
            filterData={filterValue}
            handleMultiSelect={handleMultiSelect}
            handleFilter={handleFilter}
            handleReset={handleSearchFilter}
            numberOfPage={filterValue.numberOfPage}
            sellerList={sellerList}
            setSellerList={setSellerList}
            setAllSellers={setAllSellers}
          />
        )}

        {loader && <LoaderSpinner />}

        <div className="main_content cus-page-content-sec srch-pt0">
          <div className="main_content_table_history">
            <div className="tableFixHead incomingTbl">
              <Table
                className={`tableWide table-height cus-left-right-col-layout ${loader ? "disableTble" : ""
                  }`}
              >
                <thead className="tbl-btch">
                  <tr className="table-rw-batch">
                    {checkPermission(inventoryManagement, SUBF_OUTBOUND, permissionMarkedPickedOutbound, featureSubmodulePermission, props.employeePermissions) && (
                      <th width={'5%'}>
                        <input
                          type="checkbox"
                          name="isChecked"
                          checked={checkAll}
                          className="checkAll"
                          onChange={(e) => handleCheckAll(e)}
                        />
                      </th>
                    )}
                    <th width={'7%'}>Thumbnail</th>
                    <th width={'10%'}>
                      <button
                        className={handleSortingClass("outboundNumber")}
                        onClick={(e) => handleSortingColumn(e, "outboundNumber")}
                        id="outboundNumber"
                      >
                        Outbound Id {" "}
                        <i
                          className={handleSortingClass("outboundNumber", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th width={'10%'}>
                      <button
                        className={handleSortingClass("marketPlaceName")}
                        onClick={(e) => handleSortingColumn(e, "marketPlaceName")}
                        id="marketPlaceName"
                      >
                        MarketPlace / <br /> MarketPlace Order Id {" "}
                        <i
                          className={handleSortingClass("marketPlaceOrderId", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>

                    <th width={'15%'}>
                      Customer
                    </th>

                    <th width={'15%'}>
                      Items
                    </th>

                    {userDetails?.Value?.roleName !== 'Seller' && (
                      <th width={'15%'}>Company / <br />
                        Seller Name</th>
                    )}
                    <th width={'8%'}>
                      <button
                        className={handleSortingClass("carrierName")}
                        onClick={(e) => handleSortingColumn(e, "carrierName")}
                        id="carrierName"
                      >
                        Carrier {" "}
                        <i
                          className={handleSortingClass("carrierName", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th width={'10%'}>
                      <button
                        className={handleSortingClass("trackingNumber")}
                        onClick={(e) =>
                          handleSortingColumn(e, "trackingNumber")
                        }
                        id="trackingNumber"
                      >Tracking Number {" "}
                        <i
                          className={handleSortingClass("trackingNumber", true)}
                          aria-hidden="true"
                        ></i></button>
                    </th>
                    <th width={'8%'}>
                      <button
                        className={handleSortingClass("outboundstatus")}
                        onClick={(e) =>
                          handleSortingColumn(e, "outboundstatus")
                        }
                        id="consignmentStatus"
                      >
                        Status {" "}
                        <i
                          className={handleSortingClass("outboundstatus", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th width={'8%'}>
                      <button
                        className={handleSortingClass("createdDate")}
                        onClick={(e) =>
                          handleSortingColumn(e, "createdDate")
                        }
                        id="consignmentStatus"
                      >
                        Created Date {" "}
                        <i
                          className={handleSortingClass("createdDate", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th width={'13%'} className="sticky">Action</th>
                  </tr>
                </thead>
                <tbody className="tbl-bt-body">
                  {outBoundlist.map((item, listIndex) => (
                    <tr key={item.id} className={`${item.isChecked ? "checkedRow" : ""}`}>
                      {checkPermission(inventoryManagement, SUBF_OUTBOUND, permissionMarkedPickedOutbound, featureSubmodulePermission, props.employeePermissions) && (
                        <td>
                          <input
                            type="checkbox"
                            name="isChecked"
                            checked={item.isChecked}
                            className="checkBoxItem"
                            onChange={(e) => handleCheckItem(e, listIndex)}
                            disabled={!(item.consignmentOrder === 2 || item.consignmentOrder === 3)}
                          />
                        </td>
                      )}
                      <td>
                        {item.thumbnail && (
                          <button
                            className="thumbImg sortBtn"
                            onClick={() => {
                              setSelectedRecord({ imageUrl: item.thumbnail });
                              setShowHideImageModal(!showHideImageModal);
                            }}
                          >
                            <img
                              src={item.thumbnail}
                              alt=""
                              style={{ height: "24px" }}
                            />
                          </button>
                        )}
                      </td>
                      <td>{item.outboundNumber}</td>
                      <td>{item.marketPlaceName} <div>{item.marketPlaceOrderId}</div></td>
                      <td>
                        <b style={{ fontWeight: 500 }}>{item.receiverName}</b> <br /> {item.addressFirst} <br /> {item.addressSecond && <>{item.addressSecond}<br /></>}
                        <>{[item.city, item.state, item.country].filter(Boolean).join(', ')}</>
                      </td>
                      <td>
                        {item.items.length > 0 && (
                          <OutboundItemList
                            items={item.items}
                            outbound={item}
                            canView={checkPermission(inventoryManagement, SUBF_INBOUND, permssionView, featureSubmodulePermission, props.employeePermissions)}
                            handleView={() => handleNavigateToOutbound(item, "view")}
                          />
                        )}
                      </td>
                      {userDetails?.Value?.roleName !== 'Seller' && (
                        <td>{item.companySellerName}</td>
                      )}
                      <td>{item.carrierName}</td>
                      <td>{item.trackingNumber}</td>
                      <td>
                        <span className='statusTd'>
                          <span className={getStatusClass(item.outboundStatus)}>{item.outboundStatus}</span>
                        </span>
                      </td>
                      <td>{moment(item.createdDate).format("MM-DD-YYYY | h:mm:ss A")}</td>
                      <td className="sticky">
                        {checkPermission(inventoryManagement, SUBF_INBOUND, permssionView, featureSubmodulePermission, props.employeePermissions) && (
                          <ActionItems
                            type={"View"}
                            item={item}
                            handleAction={() =>
                              handleNavigateToOutbound(item, "view")
                            }
                          />
                        )}
                        {checkPermission(inventoryManagement, SUBF_INBOUND, permssionEdit, featureSubmodulePermission, props.employeePermissions) && (
                          <ActionItems
                            type={"Edit"}
                            item={item}
                            handleAction={() =>
                              handleNavigateToOutbound(item, "edit")
                            }
                          />
                        )}
                        <ActionItems
                          type={"History"}
                          item={item}
                          handleAction={() => handleHistoryPage(item)}
                        />
                      </td>
                    </tr>
                  ))}
                  {consignmentOutboundStatus === "success" &&
                    outBoundlist.length === 0 && (
                      <>{renderTableRow(12, "No Result Found...")}</>
                    )}
                </tbody>
              </Table>
            </div>
          </div>
          <ViewImage
            title={"Product Image"}
            selectedRecord={selectedRecord}
            setShowHideImageModal={setShowHideImageModal}
            showHideImageModal={showHideImageModal}
          />
          <BatchPagination
            gridData={outBoundlist}
            totalRecords={filterValue.totalRecords}
            numberOfPage={filterValue.numberOfPage}
            numOfPage={numOfPage}
            loader={loader}
            currentPage={filterValue.pageIndex}
            totalPages={filterValue.totalPages}
            setCurrentPage={setCurrentPagePagination}
            setNumberOfPage={setTotalNumberOfPage}
          />
        </div>
        {showAlert.show && (
          <AlertDialogModal
            modalShow={showAlert.show}
            handleCancelDeleteAlert={() => setShowAlert({ show: false })}
            modalClass={'modalDeleteWrapper'}
            messageText={`Are you sure you want to mark the selected outbound items as ${showAlert.actionType} ?`}
            handleYesDeleteAlert={handleChangeStatus}
            headingText={'STATUS'}
            loader={loader}
          />
        )}
        {csvModalShow && (
          <BulkUpload
            show={csvModalShow}
            formData={filterValue}
            setFormData={setFilterValue}
            handleCancel={handleUploadDialog}
            moduleId={4}
            moduleName={'outboundCsvupload'}
          />
        )}
      </div>
    </main>
  );
};


OutboundComponent.propTypes = {
  employeePermissions: PropTypes.array,
};

export default OutboundComponent;
